/* eslint-disable no-undef */
import React from 'react'
import {Helmet} from 'react-helmet'
import {useLocation, useParams} from 'react-router'
import PropTypes from 'prop-types'
import {makeStyles} from "@material-ui/styles"
import {Container} from "@material-ui/core"
import {FormattedMessage} from "react-intl"
import BreadCrumb from "./BreadCrumb"

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  }
}))

function Page({title, subTitle, children, noBread, left, ...rest}) {
  const location = useLocation()
  const classes = useStyles()
  let { id } = useParams()

  return (
    <div {...rest} className={classes.root}>

      {title.props ? <FormattedMessage id={title.props.id}>
        {title => <Helmet><title>{title}</title></Helmet>}
      </FormattedMessage> : <Helmet><title>{title}</title></Helmet>}

      <Container maxWidth={false}>
        {!noBread && <BreadCrumb title={title} subTitle={subTitle} left={left} back={id}/>}
        {children}
      </Container>
    </div>
  )
}

Page.propTypes = {
  children: PropTypes.node,
  title: PropTypes.any
}

export default Page
